import dice from "./images/icon-dice.svg";
import divider_d from "./images/pattern-divider-desktop.svg";
import divider_m from "./images/pattern-divider-mobile.svg";
import { useState } from "react";
import axios from "axios";

function App() {
    const [advice, setAdvice] = useState(
        "It is easy to sit up and take notice, what's difficult is getting up and taking action."
    );
    const [num, setNum] = useState(117);

    // const getAdvice = () => {
    //   return fetch("https://api.adviceslip.com/advice")
    //         .then((response) => response.json())
    //         .then((data) => setAdvice(data.slip.advice));
    // }

    // async function getAdvice () {
    //   return await fetch("https://api.adviceslip.com/advice")
    //         .then((response) => response.json())
    //         .then((data) => setAdvice(data.slip.advice));
    // }

    async function getAdvice() {
        await axios
            .get("https://api.adviceslip.com/advice")
            .then((res) => {
                // console.log("Received data", res.data);
                setAdvice(res.data.slip.advice);
                setNum(res.data.slip.id);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    return (
        <div className="app flex justify-center items-center h-screen">
            <div className="advice-cont bg-dgb sm:w-11/12 md:w-4/6 base:w-9/12">
                <p className="number text-ng text-sm tracking-widest pt-3 w-full text-center">
                    ADVICE #{num}
                </p>
                <p className="advice-text text-3xl text-lc xl:px-32 lg:px-16 md:px-2 text-center">
                    {advice}
                </p>
                <img
                    className="w-auto pb-8 sm:hidden"
                    src={divider_d}
                    alt="divider"
                />
                <img
                    className="w-auto pb-8 hidden sm:block"
                    src={divider_m}
                    alt="divider"
                />
                <button
                    onClick={getAdvice}
                    style={{ backgroundColor: "hsl(150, 100%, 66%)" }}
                    className="dice w-16 h-16 rounded-full flex justify-center items-center p-5"
                >
                    <img
                        className="m-auto"
                        src={dice}
                        alt="dice"
                        width={32}
                        height={30}
                    />
                </button>
            </div>
        </div>
    );
}

export default App;
